import api from './api';

/**
 * Download a file from the API as a blob.
 * @param {string} url - API endpoint path
 * @param {string} filename - Suggested download filename
 * @param {object} [params] - Optional query params
 */
export const downloadFile = async (url, filename, params = {}) => {
  const response = await api.get(url, {
    responseType: 'blob',
    params,
  });

  const blobUrl = window.URL.createObjectURL(response.data);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(blobUrl);
};
